/**
 * Media Helpers
 * Utilities for handling album art and media URLs
 */

import { supabase } from './supabaseClient';

/**
 * Get public URL for media (album art, etc.)
 * Handles both full URLs and Supabase storage paths
 */
export function getPublicMediaUrl(value: string | null | undefined): string {
  if (!value) {
    return '/placeholder-civicbeat.svg';
  }

  // Already a full URL
  if (value.startsWith('http://') || value.startsWith('https://')) {
    return value;
  }

  // Local path (starts with /) - return as-is for public folder files
  if (value.startsWith('/')) {
    return value;
  }

  // Supabase storage path - generate public URL
  // Assume it's a path in the album-art bucket (where song artwork is stored)
  const { data } = supabase.storage
    .from('album-art')
    .getPublicUrl(value);
  return data.publicUrl;
}

/**
 * Get album art URL with fallback
 */
export function getAlbumArtUrl(song: { image_url?: string | null, title?: string, artist?: string }): string {
  if (song.image_url) {
    return getPublicMediaUrl(song.image_url);
  }

  // Try to construct from artist/title (legacy support)
  if (song.artist && song.title) {
    const legacyPath = `/${song.artist} - ${song.title}.jpg`;
    return legacyPath;
  }

  return '/placeholder-civicbeat.svg';
}
